import React from 'react'
import { BarChart } from '@mui/x-charts/BarChart';
import {Grid, Typography, Divider} from "@mui/material";

const GraphicsLayout= (props:any) =>{
    const {t, isPrinting} = props
    const result = JSON.parse(localStorage.getItem("tum_leitfaden_result") as string) as any
    const input = JSON.parse(localStorage.getItem("tum_leitfaden_input") as string) as any

    const retrieveSpecificData = (columnName:string) =>{
        if(result.find((data: any) => data.name === columnName)){
            const value = result.find((data: any) => data.name === columnName)["value"]
            return value !== null && value !== undefined ? value : 0
        }
        else return 0
    }

    const createChart = (data:any,title:string,subtitle:string, isStacked:boolean) =>{
        if(isStacked){
            return(
                <Grid item xs={isPrinting ? 2.9 : 12} md={6} lg={3} xl={3} sx={{ marginLeft: 2, textAlign:'left',border: '1px solid black', backgroundColor: '#f6f6f6'}}>
                      <Typography variant="body1">
                            {title}
                        </Typography>
                    <Divider sx={{borderBottomWidth: 3, borderColor:'black'}} style={{ marginTop: 4, marginBottom:4}} />
                    <Typography variant="body2">
                        {subtitle}
                    </Typography>
                    <BarChart
                        xAxis={[{ scaleType: 'band', data: [input.period],  labelStyle: isPrinting ? { padding: 20} : {} }]}
                        series={data}
                        margin={{
                            top: isPrinting ? 150: 75
                        }}
                        height={isPrinting ? 235: 330}
                        width={isPrinting ? 200: 300}
                    />
                </Grid>
            )
        }
        else
        return (
            <Grid item xs={isPrinting ? 2.095 : 12} md={6} lg={2} xl={2} sx={{ marginLeft: isPrinting ? 1 : 2, textAlign:'left',border: '1px solid black', backgroundColor: '#f6f6f6'}}>
                <Typography variant="body1">
                    {title}
                </Typography>
                <Divider sx={{borderBottomWidth: 3, borderColor:'black'}}  />
                <Typography variant="body2">
                    {subtitle}
                </Typography>
                {isPrinting && <div>Ergebnis: {data}</div>}
                <BarChart
                    xAxis={[{ scaleType: 'band', data: [input.period] }]}
                    series={[{ data: data, color: "#1A9086"}]}
                    height={isPrinting ? 150: 300}
                    width={isPrinting ? 150: 200}
                />
            </Grid>

        );
    }

    return(
            <Grid container style={{marginLeft: 1, padding: 8, marginTop: 8}} spacing={2}>
                {createChart([Number(retrieveSpecificData("CO stor").toFixed(0))],'CO'+String.fromCodePoint(0x2082) +"-"+ t('result_page.storage'),t('result_page.per_tree') +" [kg CO" +String.fromCodePoint(0x2082)+ "/" +t('result_page.year')+ "]",false)}
                {createChart([Number((result[66]?.value || 0).toFixed(0))],t('result_page.water_usage'),t('result_page.per_tree') +" [m"+String.fromCodePoint(0x00B3)+"/"+t('year')+"]",false)}
                {createChart([
                    { data: [Number((result[62]?.value || 0).toFixed(0))], stack: 'A', label:isPrinting ? t('result_page.transpiration') +": " +((result[62]?.value || 0).toFixed(0)) : t('result_page.transpiration') ,color:"#00413D" },
                    { data: [Number((result[64]?.value || 0).toFixed(0))], stack: 'A', label:isPrinting ? t('result_page.interception') +": " +((result[64]?.value || 0).toFixed(0)) : t('result_page.interception'), color:"#136B67" },
                    { data: [Number(retrieveSpecificData("ro").toFixed(0))], stack: 'A', label:isPrinting ? t('result_page.drain') +": " +retrieveSpecificData("ro").toFixed(0) : t('result_page.drain'),color:"#1A9086"  },
                ],t('result_page.water_balance') + " [mm]","",true)}
                {createChart([Number(retrieveSpecificData("cool(tr) su").toFixed(0))],t('result_page.cooling_perspiration'),t('result_page.per_tree')+" [kWh "+t('result_page.in') + " " +t('result_page.summer') +"]",false)}
                {createChart([Number(retrieveSpecificData("cool(sh) su").toFixed(0))],t('result_page.cooling_shading'),t('result_page.per_tree')+" [kWh "+t('result_page.in')+ " " +t('result_page.summer')+"]",false)}
            </Grid>
    )
}
export default GraphicsLayout
